import { static_errors } from '@/app/common/constants'
import { RequestError } from '@/app/common/types_and_interfaces'
import z from 'zod'

const academicTermsErrorSchema = z.object({
  code: z.number(),
  message: z.string(),
  details: z.record(z.string(), z.string()),
})

export function parseAcademicTermsDateError(error: RequestError): string {
  const result = academicTermsErrorSchema.safeParse(error)
  if (!result.success) {
    return static_errors.unexpected_contact_support
  }

  const errorsAsArray = Object.values(result.data.details)

  if (errorsAsArray.length === 0) {
    return static_errors.unexpected_contact_support
  }

  return errorsAsArray.join('\n')
}
